import * as React from 'react'
import type { ListChildComponentProps } from 'react-window'

export interface CarouselItemData {
  items: unknown[]
  ItemComponent: React.ComponentType<{ item: unknown; realIndex: number }>
  isLooping: boolean
  itemWidth: number
  gap: number
}

/**
 * Row component defined outside MediaCarousel so the reference is stable.
 * react-window's PureComponent will not re-render the List if `children`
 * (this component) hasn't changed.
 */
export const CarouselItem = React.memo(function CarouselItem({
  index,
  style,
  data,
}: ListChildComponentProps<CarouselItemData>) {
  const { items, ItemComponent, isLooping, itemWidth, gap } = data
  const realIndex = isLooping ? index % items.length : index
  const item = items[realIndex]

  if (!item) {
    return null
  }

  return (
    <div style={{ ...style, width: itemWidth, marginRight: gap }}>
      <ItemComponent item={item} realIndex={realIndex} />
    </div>
  )
})
